import * as React from 'react';
import {
  List, Datagrid, Edit, Create, Show, SimpleShowLayout,
  TextField, BooleanField, DateField,
  SimpleForm, TextInput, NumberInput, BooleanInput,
  TopToolbar, Button, EditButton, ShowButton, FunctionField
} from 'react-admin';
import { useRedirect } from 'react-admin';
import ArrowBack from '@material-ui/icons/ArrowBack';

const useTxtData = {
  page: { tableName: '设备消息' },
  table: {
    id: 'ID',
    Mac: '设备MAC',
    garbageNo: '垃圾编号',
    HeartbeatTime: '心跳时间',
    FullAlert: '满载预警',
    FullAlertRefreshTime: '预警刷新时间'
  }
};

const RowAction = (props) => {
  return null;
  return (
    <div style={{ textAlign: 'right' }}>
      <EditButton {...props} /><br />
      <ShowButton {...props} />
    </div>
  );
};

export const LFDeviceMessageList = (props) => (
  <List {...props} title={useTxtData.page.tableName + '列表'} sort={{ field: 'id', order: 'DESC' }}
    exporter={false}
    bulkActionButtons={false}

  >
    <Datagrid>
      <TextField label={useTxtData.table.id} source="id" />
      <TextField label={useTxtData.table.Mac} source="Mac" />
      <FunctionField label={useTxtData.table.garbageNo} render={({ garbageNo }) =>
        // <TextField label={useTxtData.table.garbageNo} source="garbageNo" />
        <span>{garbageNo - 2}</span>
      }
      />
      <DateField label={useTxtData.table.HeartbeatTime} source="HeartbeatTime" showTime />
      <BooleanField label={useTxtData.table.FullAlert} source="FullAlert" />
      <DateField label={useTxtData.table.FullAlertRefreshTime} source="FullAlertRefreshTime" showTime />
      <RowAction />
    </Datagrid>
  </List>
);

export const LFDeviceMessageShow = (props) => {
  const redirect = useRedirect();
  return (
    <Show title={'查看' + useTxtData.page.tableName} {...props} actions={
      <TopToolbar>
        <Button label="返回列表" onClick={() => redirect('/Admin/LFDeviceMessage')} variant="text">
          <ArrowBack />
        </Button>
      </TopToolbar>
    }>
      <SimpleShowLayout>
        <TextField label={useTxtData.table.id} source="id" />
        <TextField label={useTxtData.table.Mac} source="Mac" />
        <TextField label={useTxtData.table.garbageNo} source="garbageNo" />
        <DateField label={useTxtData.table.HeartbeatTime} source="HeartbeatTime" />
        <BooleanField label={useTxtData.table.FullAlert} source="FullAlert" />
        <DateField label={useTxtData.table.FullAlertRefreshTime} source="FullAlertRefreshTime" />
      </SimpleShowLayout>
    </Show>
  );
};

export const LFDeviceMessageEdit = (props) => (
  <Edit title={'编辑' + useTxtData.page.tableName} {...props}>
    <SimpleForm>
      <TextInput label={useTxtData.table.Mac} source="Mac" />
      <NumberInput label={useTxtData.table.garbageNo} source="garbageNo" />
      <BooleanInput label={useTxtData.table.FullAlert} source="FullAlert" />
    </SimpleForm>
  </Edit>
);

export const LFDeviceMessageCreate = (props) => (
  <Create title={'新增' + useTxtData.page.tableName} {...props}>
    <SimpleForm>
      <TextInput label={useTxtData.table.Mac} source="Mac" />
      <NumberInput label={useTxtData.table.garbageNo} source="garbageNo" defaultValue={0} />
      <BooleanInput label={useTxtData.table.FullAlert} source="FullAlert" defaultValue={false} />
    </SimpleForm>
  </Create>
);